import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { Message } from '@paypalcorp/worldready-react'
import { Button, BlockIcon } from '@paypalcorp/pp-react'

import useAnalytics from '@/hooks/useAnalytics'
import IconPage from 'components/common/IconPage'
import { goToCancelUri } from 'utils/navigate'
import { getShortProductName } from 'utils/server-data'
import COMMON_FPTI_TAGS from '@/constants/fpti-tags/common'

const { payrollPartnerErrorActivityTags } = COMMON_FPTI_TAGS

export function PayrollPartnerError({ flowName, errorType, errorMessage }) {
  const { errorPageImpressionTags, okBtnClickTags, errorPageActivityTags } = useMemo(
    () => payrollPartnerErrorActivityTags(flowName),
    [flowName],
  )

  const { recordClientClick, recordClientEvent } = useAnalytics({
    ...errorPageImpressionTags,
    errorType,
    errorMessage,
  })
  recordClientEvent(errorPageActivityTags)

  const onOkClick = () => {
    recordClientClick(okBtnClickTags)

    goToCancelUri()
  }

  const shortProductName = getShortProductName()

  return (
    <React.Fragment>
      <IconPage
        data-testid="payroll-partner-error-page"
        icon={<BlockIcon size="xl" color="sysColorPrimaryMain" />}
        headerId="error.payrollPartner.header"
        contentId="error.payrollPartner.content"
        contentProps={{ shortProductName }}
        wrapWithModalContent
      >
        <Button data-testid="payroll-partner-ok-button" onClick={onOkClick}>
          <Message id="common.button.ok" />
        </Button>
      </IconPage>
    </React.Fragment>
  )
}

PayrollPartnerError.propTypes = {
  flowName: PropTypes.string,
  errorType: PropTypes.string,
  errorMessage: PropTypes.string,
}
